import { attr, html, on, TNode } from '@tempots/dom'
import { Logo } from './logo'
import { Anchor } from '@tempots/ui'
import { Track } from '@/services/track'

export type PageHeaderOptions = {
  center?: TNode
  right?: TNode
  logoLinked?: boolean
}

export function PageHeader({ center, logoLinked, right }: PageHeaderOptions) {
  return html.header(
    attr.class(
      'grid grid-cols-[auto_1fr_auto] md:grid-cols-3 items-center gap-2 md:gap-0 p-2 px-0 pl-2 md:px-2 bg-white border-b border-gray-300 h-full'
    ),
    // Logo - always visible
    html.div(
      attr.class('flex-shrink-0'),
      logoLinked === true
        ? Logo({ size: 'header' })
        : Anchor(
            { href: '/' },
            on.click(() =>
              Track.click({
                section: 'header',
                element_type: 'link',
                click_action: 'navigate',
                element_id: 'home',
              })
            ),
            Logo({ size: 'header' })
          )
    ),
    // Center content - hidden on small mobile, visible on sm+
    html.div(
      attr.class('hidden sm:flex flex-row justify-center items-center'),
      html.div(center)
    ),
    // Right content - always visible
    html.div(
      attr.class('flex flex-row justify-end items-center'),
      html.div(right)
    )
  )
}
